import { useEffect, useState } from "react";
import './meetinginfo.css'
import { AiOutlineClose } from "react-icons/ai";
import TimeFormatter from "../../utility/TimeFormatter";
import GetImage from "../../components/getimage/Getimage";
import flagicon from "../../assets/flag_icon-transformed.png"
import Myedit from "../../assets/edit-transformed.png"
import mydeleteinfo from "../../assets/delete-transformed.png"
import "../../pages/Ticketdiv/components/subcomps/ticketinfo.css"
import { TicketScore } from "../../components/ticketscore/Ticketscore";
import getMeetingTime from "./utility/getMeetingTime";
import GetHrsTime from "../../utility/GetHrsTime";
import { showConfirm } from "../../utility/showconfirm";
import Loader from "../../components/loader/Loader";
import Hexapi from "../../utility/HexAPI/Hexapi";
import { Modal } from "react-bootstrap";
import meeticon from "../../assets/meet_icon.png"
import CustomSocial from "../../components/customsocial/Customsocial";
import Editmeeting from "./addmeeting/Editmeeting";
import Micicon from "../../assets/mic.png"
import { IoShareSocialOutline } from "react-icons/io5";
import Tint from "../../utility/ImageTint/Tint";
import { Tooltip } from "antd";
import Flagmodal from "../../components/flagcomponent/Flagmodal";
import { showCustomSwal } from "../../components/customswal/Customswal";
const Meetinginfo = ({ info,isAttendee,setisInfo,userid ,getMeetingListData ,GetMeetingDetails}) => {

 const [dataSet, setDataSet] = useState(null);
 const [loading, setLoading] = useState(false);
 const[refershow,setrefershow] =useState(false)
 const [flagshow,setflagshow]=useState(false)
  const[empidflag,setempidflag]=useState("")
  const[empnameflag,setempnameflag]=useState("")
  let flagtext ="Raise Flag";
 const handleflag=(e,id,name)=>{
  e.stopPropagation()
  setflagshow(true)
  setempidflag(id)
  setempnameflag(name)
}
 const [show,setshow]=useState(false)
 const getData=()=>{
    const data=info
    const ids = data.empids.split(",");
const names = data.empnames.split(",");
const actions = data.emprsvpactions.split("$#12$$");
const logTimes = data.emprsvplogtime.split("$#12$$");
const remarks = data.emprsvpremarks.split("$#12$$");
const presents = data.presents.split(",");
const scores = data.scores.split(",");
  
const datasetAll = ids.map((id, index) => ({
  empid: Number(id),
  empname: names[index],
  rsvpaction: Number(actions[index]),
  rsvplogtime: logTimes[index],
  rsvpremarks: remarks[index] === "-1" || remarks[index] == "" ? null : remarks[index],
  present: Number(presents[index]),
  score: Number(scores[index])
}));

setDataSet(datasetAll);

  }

  const handleDeleteMeeting = async () => {
 const result = await showConfirm({
  content:"Are you sure you want to cancel this meeting?",
  okText:"Yes",
  cancelText:"No",
  hideCancel:false
 })
 if (!result) return;
  try {

    setLoading(true);

    const obj = {
      query: "HRApp_Droid_Proc_User_Meeting_Cancel @UserID='{0}' , @MeetingID='{1}'",
      queryArr: [`${userid}`, `${info?.meetingid}`]
    };

    const res = await Hexapi(obj);
console.log(res,"res")
if(res && res[""] && res[""][0]){
  if(res[""][0].command == 1){
showConfirm({
  content:res[""][0].msg,
  hideCancel:true
}).then(()=>{
  getMeetingListData()
  GetMeetingDetails()
})
  }else{
showConfirm({
  content:res[""][0].msg,
  hideCancel:true
})
  }
}

  } catch (error) {
     if(error.message =="SQL Error occurred"){
          showCustomSwal("error occurred please try again")
        }
    console.error(error);
  } finally {
    setLoading(false);
  }
};
  const rsvpaction = (rsvp,rsvplogtime)=>{
    let str =""

    if(rsvp == 1){
      const data =TimeFormatter(rsvplogtime)

      str = `RSVP'd Yes at ${data.ShiftTime} , ${data?.ShiftDate.split("-")[2]} ${data.shiftFullMonth}`
    }else if(rsvp == -1){
      const data =TimeFormatter(rsvplogtime)

      str = `RSVP'd No at ${data.ShiftTime} , ${data?.ShiftDate.split("-")[2]} ${data.shiftFullMonth}`
    }else{
      str = "RSVP Pending"
    }
    return str;
  }
  useEffect(()=>{
    if(isAttendee && isAttendee.length > 0){
      getData()
    }
  },[isAttendee])
  let createdtime=""
  let time = TimeFormatter(info?.createdtime?.date)
            createdtime = `Created by ${info?.createdbyempname} on ${time.ShiftTime}, ${time.userSplitedDate[2]} ${time.fullMonthName}`

   let startdate = `${getMeetingTime(info?.scheduledtime?.date)} , ${time.userSplitedDate[2]} ${time.fullMonthName} ${GetHrsTime(info?.duration)}`

  return (
    <div className="infosetmain" style={{backgroundColor:"white"}}>
      {loading && <Modal style={{backdropFilter:"blur(4px)"}} centered show={loading}>
        <Modal.Body>
          <Loader />
        </Modal.Body>
        </Modal>}
<div className="infohead">
  <div className="editdeletesec">
<p style={{fontWeight:"700",marginBottom:"0px", color:"rgb(31 41 55)" , fontSize:"17px"}}>Meeting Info</p>
{info?.allowdelete == 1 ?
     <div className='mydeleteinfoo' onClick={()=>handleDeleteMeeting()} >
    <img src={mydeleteinfo} className=' img-fluid wid-img-1o cur-point white-icono'  />
      </div>
       : null}

{ info?.allowedit == 1  ?  <div className='myedito cur-point' onClick={()=>setshow(true)} >
     <img src={Myedit} className='img-fluid wid-img-1o' />
      </div>: null
}
  </div>
<div>
  <p style={{marginBottom:"0px" , cursor:"pointer"}} onClick={()=>setisInfo(false)}><AiOutlineClose /></p>
</div>
</div>

<div className="desmeeting" style={{color:"#2f2c2c"}}>
  {
    info?.scheduledtime?.date && <p className="colorset" style={{marginBottom:"0px",marginTop:"10px" , fontSize:"16px"}}>{startdate}</p>
  }
 
  {
    info?.createdtime?.date &&   <p className="colorgray" style={{marginBottom:"0px" , fontWeight:500, marginTop:"6px"}}>{createdtime}</p>
  }

</div>
<div className="desmeeting">
  <p style={{fontWeight:"600",marginBottom:"0px" , color:"#29b6f6",marginTop:"10px"}}>Description</p>
  <p className="colorset" style={{marginBottom:"0px"}}>{info?.description || "No Description"}</p>
</div>
{
 ( info?.meetlink != -1 && info?.meetlink) && <div className="desmeeting">
  <p style={{fontWeight:"600",marginBottom:"0px" , color:"#29b6f6" ,marginTop:"10px"}}>Google Meet Link</p>
  <div style={{display:"flex" , justifyContent:"space-between" , alignItems:"center"}}>
  <p style={{marginBottom:"0px" , whiteSpace:"pre-wrap" , wordBreak:"break-word"}} className="colorset">{info?.meetlink}</p>
  <div style={{display:"flex" , gap:"10px" , alignItems:"center"}} >
    <img src={meeticon} style={{width:"18px" , height:"18px", cursor:"pointer"}}  onClick={(e) => {
      e.stopPropagation();
      window.open(info?.meetlink, "_blank"); 
    }}
     onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    />
 <p  style={{marginBottom:"0px"}} className='iconcss' onClick={() => setrefershow(true)}>
                      <IoShareSocialOutline  style={{fontSize:"16px", color:"#9ca3af" ,fontWeight:"700" , marginBottom:"4px"}} />
                    </p>
    </div>
    </div>
</div>
}

<div className="desmeeting">
  <p style={{fontWeight:"600",marginBottom:"0px" , color:"#29b6f6" ,marginTop:"10px"}}>Location</p>
  <p style={{marginBottom:"0px"}} className="colorset">{info?.location}</p>
</div>


{dataSet && dataSet.length > 0 ? <div>
  <p  style={{fontWeight:"600",marginBottom:"0px" ,color:"#29b6f6" , marginTop:"10px"}}>Participants</p>
  <div style={{display:"flex", flexDirection:"column", gap:"10px"}}>

    {dataSet.map((item, index) => (
      <div key={index} style={{display:"flex", justifyContent:"space-between", padding:"5px 0"}}>
        <div style={{display:"flex" , gap:"10px", alignItems:"center"}}>
            <div
    style={{
      border: item.present == 1 ? "3px solid #28a745" : "",
      borderRadius: "50%",
      padding: "2px"
    }}
  >
          <GetImage imgID={item.empid} width="40px" height="40px" />
        </div>
        <div>
        <p style={{marginBottom:"0px"}} className="colorset">{item?.empname}</p>
        <p  style={{fontSize:"12px", marginBottom:"0px",color:item.rsvpaction == 1 ? "#28a745" : item.rsvpaction == -1 ? "#dc2626" : "#9ca3af"}}>{rsvpaction(item.rsvpaction,item.rsvplogtime)}</p>
          </div>
          </div>
          <div style={{display:"flex",alignItems:"center"}}>
            {
              item?.empid == info?.hostempid &&  <div style={{color:"#dc2626", fontSize:"22px"}}>
             <img src={Micicon} style={{width:"20px" , filter:Tint("#ff0000")}}/>
              </div>
            }

             <div>
            <TicketScore kpiscore={item?.score}/>
            </div>
            {
              (info?.allowredflag == 1 && item.empid != userid)  &&
             <Tooltip title={flagtext} placement="left"><img  src={flagicon} className="img-fluid" style={{width:"35px", cursor:"pointer"}} onClick={(e)=>handleflag(e,item.empid,item.empname)} /></Tooltip>
            }
             {/* <Tooltip title={flagtext} placement="left"><img src={flagicon} className="img-fluid" style={{width:"35px"}} onClick={(e)=>handleflag(e,item.empid,item.empname)} /></Tooltip> */}
       <div>

        </div>
            </div>

      </div>
    ))}
  </div>
</div> : <p>No participants data available</p>
}

 { (info?.meetlink !=-1 && refershow) &&
      <CustomSocial ismeet={true} show={refershow} hide={() => setrefershow(false)} data={{sharemsg:info?.meetlink}} />
    }
    {
      <Editmeeting GetMeetingDetails={GetMeetingDetails} getMeetingListData={getMeetingListData} meetingid={info?.meetingid} show={show} hide={()=>setshow(false)}/>
    }
    {flagshow && <Flagmodal activitytypee={2} show={flagshow} hide={()=>{setflagshow(false)}} ticketinfo={info} userId={userid} empidflag={empidflag} empnameflag={empnameflag}/> }
    
    </div>
  );
};

export default Meetinginfo;